import * as React from "react"
import { Text, Button, ButtonProps } from "@chakra-ui/react"
import { AiFillLinkedin } from "react-icons/ai"

type AdditionProps = {
  onlyIcon?: boolean
}

export const LinkedinButton: React.FC<ButtonProps & AdditionProps> = React.memo(
  ({ onlyIcon, ...props }) => {
    return (
      <Button
        background="#0072b1"
        color="white"
        width="130px"
        marginTop="1rem"
        _active={{}}
        _hover={{}}
        _focus={{}}
        {...props}
      >
        <AiFillLinkedin />
        {!onlyIcon && <Text marginLeft="0.5rem">Linkedin</Text>}
      </Button>
    )
  }
)
